import { ArgusAPI } from './argusApi';
import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export const argusApiRef: ApiRef<ArgusAPI> = createApiRef<ArgusAPI>({ id: 'argus.api' });
